module.exports = __webpack_public_path__ + "img/tv_default.4a3678ab.jpg";